export function news() {
    Alpine.data("news", () => ({
        wordCount: 0,
        readingTime: 0,
        readingProgress: 0,
        init() {
            this.getReadingTime();
            this.getReadingProgress();
        },
        getTextElement() {
            return this.$el.querySelector('#text');
        },
        getReadingTime() {
            const textElement = this.getTextElement();
            if (!textElement) return 0;
            const text = textElement.innerText || textElement.textContent || '';
            this.wordCount = text.trim().split(/\s+/).filter(word => word.length > 0).length;
            const wordsPerMinute = 200;
            this.readingTime = Math.ceil(this.wordCount / wordsPerMinute);
        },
        getReadingProgress() {
            const textElement = this.getTextElement();
            if (!textElement) return 0;
            const text = textElement.innerText || textElement.textContent || '';
            const wordCount = text.trim().split(/\s+/).filter(word => word.length > 0).length;
            const wordsPerMinute = 200;
            const totalMinutes = wordCount / wordsPerMinute;
            const maxMinutes = 10;
            this.readingProgress = Math.min((totalMinutes / maxMinutes) * 100, 100);
        }
    }));
    window.share = (customURL = null) => {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                url: customURL !== null ? customURL : window.location.href
            });
        } else {
            const fallbackEls = document.querySelectorAll(".sharing-fallback");
            const sharingButtons = document.querySelectorAll(".sharing-button");
            for (let el of fallbackEls) {
                el.removeAttribute("hidden");
            }
            for (let el of sharingButtons) {
                el.setAttribute("hidden", "true");
            }
        }
    }
    
}
